/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon32Regular = forwardRef('TechPowerButtonIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M17 2a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0V2Z" }),
        React.createElement("path", { d: "M10.5 6.474a1 1 0 1 0-1-1.732 13 13 0 1 0 13 0 1 1 0 1 0-1 1.732 11 11 0 1 1-11 0Z" })));
});
